import address from './address'
import manager from './manager'
import houseNumberValidCharacters from './houseNumberValidCharacters'
import nameValidCharacters from './nameValidCharacters'

export default {
  address,
  manager,
  houseNumberValidCharacters,
  nameValidCharacters
}
